<template>
<!-- <CRow v-if="coupon.coupon_method === false">
    <CCol class="cursor-pointer" col="12" sm="4" @click="coupon.coupon_method = CouponMethod.GENERAL">
        <CCard>
            <CCardBody>
                <h6 class="text-center mb-3">کد تخفیف عمومی(برای همه بازاریابان)</h6>
                <span class="text-muted text-center d-block">این کد تخفیف به همه بازاریابانی که با شما همکاری می‌کنند نشان داده خواهد شد.</span>
            </CCardBody>
        </CCard>
    </CCol>
    <CCol class="cursor-pointer" col="12" sm="4" @click="coupon.coupon_method = CouponMethod.PRIVATE">
        <CCard>
            <CCardBody>
                <h6 class="text-center mb-3">کد تخفیف اختصاصی(انتخاب از بین بازاریابان)</h6>
                <span class="text-muted text-center d-block">این کد تخفیف تنها به بازاریابانی که انتخاب می‌کنید نشان داده خواهد شد.</span>
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
<CRow v-else>
    <CCol col="12" sm="7">
        <CButton color="dribbble" class="mb-1 float-right" @click="coupon.coupon_method = false">
            {{ $t('back') }}
            <FaIcon icon="chevron-left" />
        </CButton>
    </CCol>
    <CCol col="12" sm="7">
        <CCard>
            <CCardBody>
                <Form />
            </CCardBody>
        </CCard>
    </CCol>
</CRow> -->
<CContainer>
    <CRow v-if="!storeId">
        <CCol col="12" sm="8" class="mx-auto">
            <CCard>
                <CCardBody>
                    <CListGroup style="max-height:300px;overflow-y:scroll;">
                        <CListGroupItem v-for="(store, index) in stores" :key="index" href="#" @click="setStore(store.id)">
                            <!-- <CImg style="width:50px;max-height:50px;" thumbnail :src="store.logo" placeholderColor="#ddd" /> -->
                            <span class="mfs-2 d-inline-block">{{ store.name }}</span>
                        </CListGroupItem>
                    </CListGroup>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
    <div v-else-if="coupon.coupon_method === false">
        <CRow v-if="!$policy('store').create_own">
            <CCol col="12" sm="8" class="mx-auto">
                <BackBtn @click="storeId = false" />
            </CCol>
        </CRow>
        <CRow class="content-center">
            <CCol class="cursor-pointer" col="12" sm="4" @click="coupon.coupon_method = CouponMethod.GENERAL">
                <CCard>
                    <CCardBody>
                        <h6 class="text-center mb-3">کد تخفیف عمومی(برای همه بازاریابان)</h6>
                        <span class="text-muted text-center d-block">این کد تخفیف به همه بازاریابانی که با شما همکاری می‌کنند نشان داده خواهد شد.</span>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol class="cursor-pointer" col="12" sm="4" @click="coupon.coupon_method = CouponMethod.PRIVATE">
                <CCard>
                    <CCardBody>
                        <h6 class="text-center mb-3">کد تخفیف اختصاصی(انتخاب از بین بازاریابان)</h6>
                        <span class="text-muted text-center d-block">این کد تخفیف تنها به بازاریابانی که انتخاب می‌کنید نشان داده خواهد شد.</span>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
    <CRow v-else>
        <CCol col="12" sm="7" class="mx-auto">
            <BackBtn @click="noBack ? storeId = false : coupon.coupon_method = false" />
        </CCol>
        <CCol col="12" sm="7" class="mx-auto">
            <CCard>
                <CCardBody>
                    <Form :coupon="coupon" :submit="submit" ref="createForm" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</CContainer>
</template>

<script>
import { Form } from './partials'
import { mapActions, mapGetters } from 'vuex'
import { StoreUserRelationStatus, CouponMethod, StoreStatus } from '@/constants'

export default {
    name: 'CreateCoupon',

    components: {
        Form
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchStores({
                no_paginate: true,
                just: ['id', 'name', 'logo'],
                status: StoreStatus.ACTIVE
            })
        })
    },

    data() {
        return {
            CouponMethod,

            noBack: this.$route.params.method !== undefined,

            coupon: {
                status: 2,
                is_unique: 0,
                type: 0,
                limit_amount: null,
                amount: null,
                unlimited: true,
                code_file: null,
                coupon_type: 0,
                users: [],
                // reduction_rate: '',
                coupon_method: this.$route.params.method !== undefined ? this.$route.params.method : false,
                finished_at: null,
                store_id: this.$currentUser().store ? this.$currentUser().store.id : null,
            }
        }
    },

    computed: {
        ...mapGetters('store', [
            'stores'
        ]),
        storeId: {
            get() {
                return this.coupon.store_id || this.$route.query.store_id || false
            },
            set(newVal) {
                this.coupon.store_id = newVal
            }
        },
        showBack() {
            return this.$route.query.store_id ? false : true
        },
    },
    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
            fetchPublishers: 'publisher/fetch',
            createCoupon: 'coupon/create',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        submit() {
            const createForm = this.$refs.createForm
            this.setShowLoading()
            this.resetMsg()


            let data = Object.assign({}, this.coupon)
            data.users = data.users.map(user => user.id)

            this.createCoupon(data).then(() => {
                this.setShowLoading(false)
                this.$router.push({name: 'coupons'})
            }).catch(result => {
                if(result.data) {
                    createForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
        setStore(storeId) {
            this.fetchPublishers({
                store_id: storeId,
                status: StoreUserRelationStatus.ACTIVE,
                no_paginate: true,
            }).then(result => this.storeId = storeId)
        }
    }
}
</script>